const truncateRegex = /^(.{4}).*?(.{4})$/;

/**
 * Truncates a string to keep exactly 4 chars at start and end
 * @param str Full string to truncate
 * @returns Truncated string
 */
const truncateByHalf = (str: string) => {
  if (str.length <= 8) return str;

  const match = str.match(truncateRegex);

  if (!match) return str;

  return `${match[1]}...${match[2]}`;
};

const e = {
  format: {
    truncateByHalf,
  },
};

export default e;
